import HeadPt from './Head.pt.json'
import HeadEn from './Head.en.json'
import HeadEs from './Head.es.json'
import DifferentialsPt from './Differentials.pt.json'
import DifferentialsEn from './Differentials.en.json'
import DifferentialsEs from './Differentials.es.json'
import LocationPt from './Location.pt.json'
import LocationEn from './Location.en.json'
import LocationEs from './Location.es.json'
import ApartmentsPt from './Apartments.pt.json'
import ApartmentsEn from './Apartments.en.json'
import ApartmentsEs from './Apartments.es.json'
import CommonAreasPt from './CommonAreas.pt.json'
import CommonAreasEn from './CommonAreas.en.json'
import CommonAreasEs from './CommonAreas.es.json'
import DesignersPt from './Designers.pt.json'
import DesignersEn from './Designers.en.json'
import DesignersEs from './Designers.es.json'
import DimasPt from './Dimas.pt.json'
import DimasEn from './Dimas.en.json'
import DimasEs from './Dimas.es.json'
import DormitoriesPt from './Dormitories.pt.json'
import DormitoriesEn from './Dormitories.en.json'
import DormitoriesEs from './Dormitories.es.json'
import DVertResidenceClubPt from './DVertResidenceClub.pt.json'
import DVertResidenceClubEs from './DVertResidenceClub.es.json'
import DVertResidenceClubEn from './DVertResidenceClub.en.json'
import GreenPt from './Green.pt.json'
import GreenEn from './Green.en.json'
import GreenEs from './Green.es.json'
import HeroPt from './Hero.pt.json'
import HeroEn from './Hero.en.json'
import HeroEs from './Hero.es.json'
import ResidenceClubPt from './ResidenceClub.pt.json'
import ResidenceClubEn from './ResidenceClub.en.json'
import ResidenceClubEs from './ResidenceClub.es.json'
import SpacesPt from './Spaces.pt.json'
import SpacesEn from './Spaces.en.json'
import SpacesEs from './Spaces.es.json'
import SustainablePt from './Sustainable.pt.json'
import SustainableEn from './Sustainable.en.json'
import SustainableEs from './Sustainable.es.json'
import PlantsPt from './Plants.pt.json'
import PlantsEn from './Plants.en.json'
import PlantsEs from './Plants.es.json'
import ContactPt from './Contact.pt.json'
import ContactEn from './Contact.en.json'
import ContactEs from './Contact.es.json'
import SustainableDataPt from './SustainableData.pt.json'
import SustainableDataEn from './SustainableData.en.json'
import SustainableDataEs from './SustainableData.es.json'
import CommonAreasDataPt from './CommonAreasData.pt.json'
import CommonAreasDataEn from './CommonAreasData.en.json'
import CommonAreasDataEs from './CommonAreasData.es.json'
import HamburguerPt from './Hamburguer.pt.json'
import HamburguerEn from './Hamburguer.en.json'
import HamburguerEs from './Hamburguer.es.json'
import MenuBarPt from './MenuBar.pt.json'
import MenuBarEn from './MenuBar.en.json'
import MenuBarEs from './MenuBar.es.json'
import DifferentialsSVGPt from './DifferentialsSVG.pt.json'
import DifferentialsSVGEn from './DifferentialsSVG.en.json'
import DifferentialsSVGEs from './DifferentialsSVG.es.json'
import WorkModalPt from './WorkModal.pt.json'
import WorkModalEn from './WorkModal.en.json'
import WorkModalEs from './WorkModal.es.json'

import { translatePath as _translatePath } from './translatePath'

export const resources = {
  pt: {
    translation: {
      Head: HeadPt,
      Differentials: DifferentialsPt,
      Location: LocationPt,
      Apartments: ApartmentsPt,
      CommonAreas: CommonAreasPt,
      Designers: DesignersPt,
      Dimas: DimasPt,
      Dormitories: DormitoriesPt,
      DVertResidenceClub: DVertResidenceClubPt,
      Green: GreenPt,
      Hero: HeroPt,
      ResidenceClub: ResidenceClubPt,
      Spaces: SpacesPt,
      Sustainable: SustainablePt,
      Plants: PlantsPt,
      Contact: ContactPt,
      SustainableData: SustainableDataPt,
      CommonAreasData: CommonAreasDataPt,
      Hamburguer: HamburguerPt,
      MenuBar: MenuBarPt,
      DifferentialsSVG: DifferentialsSVGPt,
      WorkModal: WorkModalPt,
    },
  },
  en: {
    translation: {
      Head: HeadEn,
      Differentials: DifferentialsEn,
      Location: LocationEn,
      Apartments: ApartmentsEn,
      CommonAreas: CommonAreasEn,
      Designers: DesignersEn,
      Dimas: DimasEn,
      Dormitories: DormitoriesEn,
      DVertResidenceClub: DVertResidenceClubEn,
      Green: GreenEn,
      Hero: HeroEn,
      ResidenceClub: ResidenceClubEn,
      Spaces: SpacesEn,
      Sustainable: SustainableEn,
      Plants: PlantsEn,
      Contact: ContactEn,
      SustainableData: SustainableDataEn,
      CommonAreasData: CommonAreasDataEn,
      Hamburguer: HamburguerEn,
      MenuBar: MenuBarEn,
      DifferentialsSVG: DifferentialsSVGEn,
      WorkModal: WorkModalEn,
    },
  },
  es: {
    translation: {
      Head: HeadEs,
      Differentials: DifferentialsEs,
      Location: LocationEs,
      Apartments: ApartmentsEs,
      CommonAreas: CommonAreasEs,
      Designers: DesignersEs,
      Dimas: DimasEs,
      Dormitories: DormitoriesEs,
      DVertResidenceClub: DVertResidenceClubEs,
      Green: GreenEs,
      Hero: HeroEs,
      ResidenceClub: ResidenceClubEs,
      Spaces: SpacesEs,
      Sustainable: SustainableEs,
      Plants: PlantsEs,
      Contact: ContactEs,
      SustainableData: SustainableDataEs,
      CommonAreasData: CommonAreasDataEs,
      Hamburguer: HamburguerEs,
      MenuBar: MenuBarEs,
      DifferentialsSVG: DifferentialsSVGEs,
      WorkModal: WorkModalEs,
    },
  },
}

export const translatePath = _translatePath as (path: string) => string
